import React, { useEffect, useState, useCallback } from 'react';
import {
    Box, TextField, Paper, Button, Typography, MenuItem,
    Card, Divider, CardContent, Pagination,
    CircularProgress, Grid, Modal, CardHeader, IconButton,
    TableContainer, Table, TableHead, TableRow, TableCell, TableBody, InputAdornment
} from '@mui/material';
import { toast } from 'react-toastify';
import CloseIcon from '@mui/icons-material/Close';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import apiService from '../../services/actions';
import RefreshOutlinedIcon from "@mui/icons-material/RefreshOutlined";

function MobiLabusers() {
    const loginObjStr = localStorage.getItem('loginObj');
    const loginObj = JSON.parse(loginObjStr);
    const userCode = loginObj?.userSession?.userCode || null;
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [tableList, setTableList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [mode, setMode] = useState('Add');
    const [currentPage, setCurrentPage] = useState(1);
    const rowsPerPage = 10;

    const [userData, setUserData] = useState({
        name: '',
        username: '',
        phone: '',
        status: '1',
        password: '',
        confirmPassword: '',
        mobilabId: ''
    });
    const [addUser, setAddUser] = useState(false);
    const [filterModal, setFilterModal] = useState(false);
    const [filterObj, setFilterObj] = useState({});

    const getTableList = useCallback(async (filterObject = {}) => {
        setCurrentPage(1);
        try {
            setLoading(true);
            const payload = Object.keys(filterObject).length > 0
                ? filterObject
                : { status: '1' };
            
            const response = await apiService.getmoblilabUsersList(payload);
            setTableList(response?.data?.user_details || []);
            setFilterObj({});
            setFilterModal(false);
        } catch (error) {
            console.error('Error fetching mapping list:', error);
            toast.error('Error fetching user list');
        } finally {
            setLoading(false);
        }
    }, []);

    const handleChange = (event) => {
        const { name, value } = event.target;
        setUserData((prev) => ({
            ...prev,
            [name]: value
        }));
    };

    const handleChangefilter = (event) => {
        const { name, value } = event.target;
        setFilterObj((prev) => ({
            ...prev,
            [name]: value
        }));
    };

    useEffect(() => {
        getTableList();
    }, [getTableList]);

    const handleModal = (user) => {
        const isEditMode = typeof user === 'object' && user !== null;
        setMode(isEditMode ? 'Edit' : 'Add');
        
        if (isEditMode) {
            setUserData({
                name: user.name || '',
                username: user.username || '',
                phone: user.phone || '',
                status: String(user.status) || '1',
                password: user.password || '',
                confirmPassword: user.password || '',
                id: user.id,
                mobilabId: user.mobilabId
            });
        } else {
            setUserData({
                name: '',
                username: '',
                phone: '',
                status: '1',
                password: '',
                confirmPassword: '',
            });
        }
        setAddUser(!addUser);
    };

    const validateForm = () => {
        const { password, confirmPassword } = userData;

        if (!password || !confirmPassword) {
            toast.error('Please enter both password and confirm password.');
            return false;
        }

        if (password !== confirmPassword) {
            toast.error('Passwords do not match.');
            return false;
        }

        return true;
    };

    const getPayload = () => {
        const basePayload = {
            name: userData.name,
            phone: userData.phone,
            username: userData.username,
            password: userData.password,
            status: Number(userData.status),
            updatedBy: userCode,
        };

        if (mode === 'Add') {
            return {
                ...basePayload,
                createdBy: userCode,
            };
        } else {
            return {
                ...basePayload,
                id: userData.mobilabId
            };
        }
    };

    const handleSave = async () => {
        if (!validateForm()) return;

        const payload = getPayload();

        try {
            setLoading(true);
            const apiCall = mode === 'Add'
                ? apiService.addMobiUser(payload)
                : apiService.updateMobiuser(payload);
                
            const res = await apiCall;
            
            if (res?.data?.user_details) {
                const action = mode === 'Add' ? 'added' : 'updated';
                toast.success(`User ${action} successfully`);
                setAddUser(false);
                getTableList();
            } else {
                toast.error(res?.data?.message || 'Error saving user');
            }
        } catch (err) {
            console.error('Error saving user:', err);
            toast.error('Error saving user');
        } finally {
            setLoading(false);
        }
    };

    const handleReset = () => {
        setFilterObj({});
        getTableList();
    };

    const handleFilterModal = () => {
        setFilterModal(!filterModal);
    };

    const handlePageChange = (event, value) => {
        setCurrentPage(value);
    };

    const handlePhoneChange = (event) => {
        const { value } = event.target;
        if (/^\d{0,10}$/.test(value)) {
            handleChange(event);
        }
    };

    const toggleShowPassword = () => {
        setShowPassword((prev) => !prev);
    };

    const toggleShowConfirmPassword = () => {
        setShowConfirmPassword((prev) => !prev);
    };

    const handleCloseModal = () => {
        setAddUser(false);
    };

    const handleCloseFilterModal = () => {
        setFilterModal(false);
    };

    const startIndex = (currentPage - 1) * rowsPerPage;
    const endIndex = currentPage * rowsPerPage;
    const paginatedList = tableList.slice(startIndex, endIndex);
    const pageCount = Math.ceil(tableList.length / rowsPerPage);

    const getRowKey = (item) => {
        return item.id || item.mobilabId;
    };

    return (
        <>
            <div style={{ display: 'flex', flexDirection: 'column', width: '100%', marginTop: '2rem' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '2rem', marginBottom: '1rem' }}>
                    <div style={{ display: 'flex', gap: '10px' }}>
                        <Typography variant="h6" sx={{ textAlign: 'left', fontWeight: '600' }}>
                            Mobilab User List
                        </Typography>
                        <Button
                            variant="outlined"
                            size="small"
                            startIcon={<RefreshOutlinedIcon />}
                            sx={{ borderRadius: "20px", textTransform: "none" }}
                            onClick={handleReset}
                        >
                            Reset
                        </Button>
                    </div>
                    {loading && (
                        <div className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 z-50 flex justify-center items-center">
                            <CircularProgress color="secondary" />
                        </div>
                    )}
                    <div className='flex gap-2 mr-10'>
                        <Button onClick={() => handleModal('Add')}>
                            <span className='font-extrabold'>+Add</span>
                        </Button>
                        <Button onClick={handleFilterModal}>
                            <span className='font-extrabold'>Filter</span>
                        </Button>
                    </div>
                </div>

                <TableContainer component={Paper} sx={{ maxHeight: 'calc(100vh - 280px)', minHeight: 350, overflow: 'auto' }}>
                    <Table stickyHeader>
                        <TableHead sx={{ bgcolor: '#f4f6f9', '& .MuiTableCell-root': { bgcolor: '#f4f6f9', fontWeight: 'bold' } }}>
                            <TableRow>
                                <TableCell sx={{ bgcolor: '#f4f6f9', fontWeight: 'bold' }}>Mobilab ID</TableCell>
                                <TableCell sx={{ bgcolor: '#f4f6f9', fontWeight: 'bold' }}>Name</TableCell>
                                <TableCell sx={{ bgcolor: '#f4f6f9', fontWeight: 'bold' }}>User Name</TableCell>
                                <TableCell sx={{ bgcolor: '#f4f6f9', fontWeight: 'bold' }}>Contact No</TableCell>
                                <TableCell sx={{ bgcolor: '#f4f6f9', fontWeight: 'bold' }}>Status</TableCell>
                                <TableCell sx={{ bgcolor: '#f4f6f9', fontWeight: 'bold' }}>View</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {tableList.length === 0 ? (
                                <TableRow>
                                    <TableCell colSpan={6} align="center">No Data</TableCell>
                                </TableRow>
                            ) : (
                                paginatedList.map((item) => (
                                    <TableRow 
                                        key={getRowKey(item)} 
                                        onDoubleClick={() => handleModal(item)} 
                                        style={{ cursor: 'pointer' }}
                                    >
                                        <TableCell>{item.mobilabId}</TableCell>
                                        <TableCell>{item.name}</TableCell>
                                        <TableCell>{item.username}</TableCell>
                                        <TableCell>{item.phone}</TableCell>
                                        <TableCell>
                                            <span className={item.status === 1 ? 'text-green-500' : 'text-red-500'}>
                                                {item.status === 1 ? 'Active' : 'Inactive'}
                                            </span>
                                        </TableCell>
                                        <TableCell>
                                            <IconButton onClick={() => handleModal(item)}>
                                                <Visibility />
                                            </IconButton>
                                        </TableCell>
                                    </TableRow>
                                ))
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>

                <Box sx={{ display: 'flex', justifyContent: 'center', marginTop: '1rem' }}>
                    <Pagination
                        count={pageCount}
                        page={currentPage}
                        onChange={handlePageChange}
                        color="primary"
                    />
                </Box>
            </div>

            <Modal open={addUser} onClose={handleCloseModal}>
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', overflowY: 'auto' }}>
                    <Card style={{ width: '80vw', maxWidth: '1200px', borderRadius: '8px' }}>
                        <CardHeader
                            title={
                                <Typography variant="h6" style={{ fontSize: '18px', fontWeight: 500 }}>
                                    {mode} Mobilab User
                                </Typography>
                            }
                            action={
                                <IconButton onClick={handleCloseModal}>
                                    <CloseIcon />
                                </IconButton>
                            }
                            style={{ backgroundColor: '#f5f5f5', borderBottom: '1px solid #e0e0e0' }}
                        />
                        <Divider />
                        <CardContent>
                            <Paper elevation={2} style={{ padding: '16px' }}>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} md={6}>
                                        <TextField
                                            name="name"
                                            label={<span>Name <span style={{ color: 'red' }}>*</span></span>}
                                            variant="outlined"
                                            size="small"
                                            placeholder="Enter name"
                                            fullWidth
                                            value={userData.name}
                                            onChange={handleChange}
                                            InputLabelProps={{ htmlFor: 'name-input' }}
                                            inputProps={{ id: 'name-input' }}
                                        />
                                    </Grid>

                                    <Grid item xs={12} md={6}>
                                        <TextField
                                            name="username"
                                            label={<span>User Name <span style={{ color: 'red' }}>*</span></span>}
                                            variant="outlined"
                                            size="small"
                                            placeholder="Enter username"
                                            fullWidth
                                            value={userData.username}
                                            onChange={handleChange}
                                            disabled={mode === 'Edit'}
                                            InputLabelProps={{ htmlFor: 'username-input' }}
                                            inputProps={{ id: 'username-input' }}
                                        />
                                    </Grid>

                                    <Grid item xs={12} md={6}>
                                        <TextField
                                            name="phone"
                                            label={
                                                <span>
                                                    Phone Number <span style={{ color: 'red' }}>*</span>
                                                </span>
                                            }
                                            variant="outlined"
                                            size="small"
                                            placeholder="Enter phone number"
                                            fullWidth
                                            value={userData.phone}
                                            onChange={handlePhoneChange}
                                            inputProps={{ 
                                                maxLength: 10,
                                                id: 'phone-input'
                                            }}
                                            InputLabelProps={{ htmlFor: 'phone-input' }}
                                        />
                                    </Grid>

                                    <Grid item xs={12} md={6}>
                                        <TextField
                                            select
                                            name="status"
                                            label={<span>Status <span style={{ color: 'red' }}>*</span></span>}
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            value={userData.status}
                                            onChange={handleChange}
                                            InputLabelProps={{ htmlFor: 'status-select' }}
                                            SelectProps={{ id: 'status-select' }}
                                        >
                                            <MenuItem value="1">Active</MenuItem>
                                            <MenuItem value="2">Inactive</MenuItem>
                                        </TextField>
                                    </Grid>

                                    <Grid item xs={12} md={6}>
                                        <TextField
                                            name="password"
                                            label={<span>Password <span style={{ color: 'red' }}>*</span></span>}
                                            variant="outlined"
                                            size="small"
                                            placeholder="Enter password"
                                            type={showPassword ? 'text' : 'password'}
                                            fullWidth
                                            value={userData.password}
                                            onChange={handleChange}
                                            InputLabelProps={{ htmlFor: 'password-input' }}
                                            inputProps={{ id: 'password-input' }}
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        <IconButton 
                                                            onClick={toggleShowPassword} 
                                                            edge="end"
                                                            aria-label={showPassword ? "Hide password" : "Show password"}
                                                        >
                                                            {showPassword ? <VisibilityOff /> : <Visibility />}
                                                        </IconButton>
                                                    </InputAdornment>
                                                )
                                            }}
                                        />
                                    </Grid>

                                    <Grid item xs={12} md={6}>
                                        <TextField
                                            name="confirmPassword"
                                            label={<span>Confirm Password <span style={{ color: 'red' }}>*</span></span>}
                                            variant="outlined"
                                            size="small"
                                            placeholder="Confirm password"
                                            type={showConfirmPassword ? 'text' : 'password'}
                                            fullWidth
                                            value={userData.confirmPassword}
                                            onChange={handleChange}
                                            InputLabelProps={{ htmlFor: 'confirm-password-input' }}
                                            inputProps={{ id: 'confirm-password-input' }}
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        <IconButton 
                                                            onClick={toggleShowConfirmPassword} 
                                                            edge="end"
                                                            aria-label={showConfirmPassword ? "Hide confirm password" : "Show confirm password"}
                                                        >
                                                            {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                                                        </IconButton>
                                                    </InputAdornment>
                                                )
                                            }}
                                        />
                                    </Grid>
                                </Grid>
                            </Paper>
                        </CardContent>
                        <CardContent>
                            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                <Button variant="contained" color="primary" onClick={handleSave}>
                                    {mode === 'Add' ? 'Save' : 'Update'}
                                </Button>
                                <Button variant="outlined" color="secondary" style={{ marginLeft: '10px' }} onClick={handleCloseModal}>
                                    Cancel
                                </Button>
                            </div>
                        </CardContent>
                    </Card>
                </div>
            </Modal>

            <Modal open={filterModal} onClose={handleCloseFilterModal}>
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', overflowY: 'auto' }}>
                    <Card style={{ width: '80vw', maxWidth: '1200px', borderRadius: '8px' }}>
                        <CardHeader
                            title={
                                <Typography variant="h6" style={{ fontSize: '18px', fontWeight: 500 }}>
                                    Filter Mobilab User
                                </Typography>
                            }
                            action={
                                <IconButton onClick={handleCloseFilterModal}>
                                    <CloseIcon />
                                </IconButton>
                            }
                            style={{ backgroundColor: '#f5f5f5', borderBottom: '1px solid #e0e0e0' }}
                        />
                        <Divider />
                        <CardContent>
                            <Paper elevation={2} style={{ padding: '16px' }}>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} md={6}>
                                        <TextField
                                            name="name"
                                            label="Name"
                                            variant="outlined"
                                            size="small"
                                            placeholder="Enter name"
                                            fullWidth
                                            value={filterObj.name || ''}
                                            onChange={handleChangefilter}
                                            InputLabelProps={{ htmlFor: 'filter-name-input' }}
                                            inputProps={{ id: 'filter-name-input' }}
                                        />
                                    </Grid>

                                    <Grid item xs={12} md={6}>
                                        <TextField
                                            name="username"
                                            label="User Name"
                                            variant="outlined"
                                            size="small"
                                            placeholder="Enter username"
                                            fullWidth
                                            value={filterObj.username || ''}
                                            onChange={handleChangefilter}
                                            InputLabelProps={{ htmlFor: 'filter-username-input' }}
                                            inputProps={{ id: 'filter-username-input' }}
                                        />
                                    </Grid>

                                    <Grid item xs={12} md={6}>
                                        <TextField
                                            name="phone"
                                            label="Phone Number"
                                            variant="outlined"
                                            size="small"
                                            placeholder="Enter phone number"
                                            fullWidth
                                            value={filterObj.phone || ''}
                                            onChange={handleChangefilter}
                                            InputLabelProps={{ htmlFor: 'filter-phone-input' }}
                                            inputProps={{ id: 'filter-phone-input' }}
                                        />
                                    </Grid>

                                    <Grid item xs={12} md={6}>
                                        <TextField
                                            select
                                            name="status"
                                            label="Status"
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            value={filterObj.status || ''}
                                            onChange={handleChangefilter}
                                            InputLabelProps={{ htmlFor: 'filter-status-select' }}
                                            SelectProps={{ id: 'filter-status-select' }}
                                        >
                                            <MenuItem value="1">Active</MenuItem>
                                            <MenuItem value="2">Inactive</MenuItem>
                                        </TextField>
                                    </Grid>
                                </Grid>
                            </Paper>
                        </CardContent>
                        <CardContent>
                            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                <Button variant="contained" color="primary" onClick={() => getTableList(filterObj)}>
                                    Search
                                </Button>
                                <Button variant="outlined" color="secondary" style={{ marginLeft: '10px' }} onClick={handleCloseFilterModal}>
                                    Cancel
                                </Button>
                            </div>
                        </CardContent>
                    </Card>
                </div>
            </Modal>
        </>
    );
}

export default MobiLabusers;